module.exports = "../static/media/tips-header-params.245d046f.jpeg";